import React from "react";
import styles from "./styles.module.css"
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import {ReactComponent as BackIcon} from "../../assets/left-chevron-icon.svg"
import { NAVIGATION_ROUTES } from "../../constant";

interface HeaderProps {
  pageTitle: string;
  routeValue?: string;
  navigate?: () => void;
}

const Header: React.FC<HeaderProps> = ({ pageTitle, routeValue = NAVIGATION_ROUTES.HOME, navigate: propNavigate }) => {
  const defaultNavigate = useNavigate();
  const navigate = propNavigate || (() => defaultNavigate(routeValue));

  const handleBack = () => {
    navigate();
  };

  return (
    <header className={styles.headerBlock}>
      <div onClick={handleBack} className={styles.backButton}>
        <BackIcon />
      </div>
      <div className={clsx(styles.pageTitle, "fontSizeSm fontWeightBold")}>{pageTitle}</div>
    </header>
  );
};

export default Header;